"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b;
var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BETSLIP_ODD_STATUSES_TO_PLACE_BET = exports.ODD_ACCEPT_STRATEGIES_MAPPING = exports.BETSLIP_GAMBLER_SETTINGS = exports.KeyPathToReducerProp = exports.BetslipSettingKey = exports.DEFAULT_AVAILABLE_STAKES = exports.DEFAULT_MAX_STAKE = exports.PARTS_OF_ERROR_CODES = exports.errorCodes = exports.ErrorCodes = exports.MIN_EXPRESS_SIZE = exports.ROUND_MAX_STAKE = exports.delayBeforeDeleteBetslipOdd = exports.ADD_BETSLIP_BET = exports.ADOPT_UNAFFECTED_BETSLIP_ODDS = exports.DELETE_BETSLIP_BET = exports.GET_MISSING_MATCHES_SUCCESS = exports.GET_MISSING_MATCHES_REQUEST = exports.CREATE_BETS_FAIL = exports.CREATE_BETS_SUCCESS = exports.CREATE_BETS_REQUEST = exports.UPDATE_BETSLIP_ODDS_BY_BET = exports.SET_INITIAL_BETSLIP = exports.TOGGLE_SYSTEM_COMBINATION = exports.CHANGE_BETSLIP_ODD_STATUS = exports.CHANGE_BETSLIP_BET_STAKE = exports.CHANGE_BETSLIP_ODD_STAKE = exports.DELETE_BETSLIP_ODD = exports.ADD_BETSLIP_ODD = exports.CHANGE_COEF_UPDATES = exports.CHOSE_BETSLIP_BET_ID = exports.DELETE_BETSLIP_ODDS = exports.CHANGE_BET_MODE = exports.NAME = void 0;
var core_1 = require("@gin-betting/core");
exports.NAME = 'betslip';
exports.CHANGE_BET_MODE = exports.NAME + "/CHANGE_BET_MODE";
exports.DELETE_BETSLIP_ODDS = exports.NAME + "/DELETE_BETSLIP_ODDS";
exports.CHOSE_BETSLIP_BET_ID = exports.NAME + "/CHOSE_BETSLIP_BET_ID";
exports.CHANGE_COEF_UPDATES = exports.NAME + "/CHANGE_COEF_UPDATES";
exports.ADD_BETSLIP_ODD = exports.NAME + "/ADD_BETSLIP_ODD";
exports.DELETE_BETSLIP_ODD = exports.NAME + "/DELETE_BETSLIP_ODD";
exports.CHANGE_BETSLIP_ODD_STAKE = exports.NAME + "/CHANGE_BETSLIP_ODD_STAKE";
exports.CHANGE_BETSLIP_BET_STAKE = exports.NAME + "/CHANGE_BETSLIP_BET_STAKE";
exports.CHANGE_BETSLIP_ODD_STATUS = exports.NAME + "/CHANGE_BETSLIP_ODD_STATUS";
exports.TOGGLE_SYSTEM_COMBINATION = exports.NAME + "/TOGGLE_SYSTEM_COMBINATION";
exports.SET_INITIAL_BETSLIP = exports.NAME + "/SET_INITIAL_BETSLIP";
exports.UPDATE_BETSLIP_ODDS_BY_BET = exports.NAME + "/UPDATE_BETSLIP_ODDS_BY_BET";
exports.CREATE_BETS_REQUEST = exports.NAME + "/CREATE_BETS:REQUEST";
exports.CREATE_BETS_SUCCESS = exports.NAME + "/CREATE_BETS:SUCCESS";
exports.CREATE_BETS_FAIL = exports.NAME + "/CREATE_BETS:FAIL";
exports.GET_MISSING_MATCHES_REQUEST = exports.NAME + "/GET_MISSING_MATCHES:REQUEST";
exports.GET_MISSING_MATCHES_SUCCESS = exports.NAME + "/GET_MISSING_MATCHES:SUCCESS";
exports.DELETE_BETSLIP_BET = exports.NAME + "/DELETE_BETSLIP_BET";
exports.ADOPT_UNAFFECTED_BETSLIP_ODDS = exports.NAME + "/ADOPT_UNAFFECTED_BETSLIP_ODDS";
exports.ADD_BETSLIP_BET = exports.NAME + "/ADD_BETSLIP_BET";
exports.delayBeforeDeleteBetslipOdd = 6000;
exports.ROUND_MAX_STAKE = 100;
exports.MIN_EXPRESS_SIZE = 2;
var ErrorCodes;
(function (ErrorCodes) {
    ErrorCodes["NotEnoughBalance1"] = "Not enough balance";
    ErrorCodes["NotEnoughBalance2"] = "not_enough_balance";
    ErrorCodes["StakeExceedsLimit"] = "Stake exceeds limit";
    ErrorCodes["StakeIsTooBig"] = "STAKE_IS_TOO_BIG";
    ErrorCodes["TicketWasRejected"] = "Ticket was rejected";
    ErrorCodes["ResponseTimedOut"] = "Response timed out";
    ErrorCodes["PlayerIp"] = "[player_ip]: This is not a valid IP address.";
    ErrorCodes["AuthCredentialsExpired"] = "auth.credentials.expired";
    ErrorCodes["AuthSessionUnknown"] = "auth.session.unknown";
    ErrorCodes["BetOnDifferentProviders"] = "Bet on different providers";
    ErrorCodes["MatchLimitExceeded"] = "Match limit exceeded";
    ErrorCodes["ApiMatchInBetStopList"] = "api_match_in_bet_stop_list";
    ErrorCodes["ApiMatchInBetStopList2"] = "SPORT_EVENT_BET_STOPPED";
    ErrorCodes["ApiMatchStatusWrong"] = "api_match_status_wrong";
    ErrorCodes["ApiMatchStatusWrong2"] = "INVALID_FIXTURE_STATUS";
    ErrorCodes["ApiMarketStatusWrong"] = "api_market_status_wrong";
    ErrorCodes["InvalidMarketStatus"] = "INVALID_MARKET_STATUS";
    ErrorCodes["ApiOddValueWrong"] = "api_odd_value_wrong";
    ErrorCodes["InvalidSelectionValue"] = "INVALID_SELECTION_VALUE";
    ErrorCodes["InvalidOddStatus1"] = "INVALID_ODD_STATUS";
    ErrorCodes["InvalidOddStatus2"] = "oddStatus";
    ErrorCodes["ApiOddStatusWrong"] = "api_odd_status_wrong";
    ErrorCodes["MinimalStakeIs"] = "[stake]: Minimal stake is: ";
    ErrorCodes["MaxStakeIs"] = "[stake]: Max stake is: ";
    ErrorCodes["PlaceRetryLimitReached"] = "place_retry_limit_reached";
    ErrorCodes["IdenticalBetIsProcessing"] = "identical_bet_is_processing";
    ErrorCodes["BetForThisPlayerIsForbidden"] = "Bet for this player is forbidden.";
    ErrorCodes["PlayerLimitCrossed"] = "player_limit_crossed";
    ErrorCodes["PlayerLimitCrossedCps2CanGamble"] = "player_limit_crossed : [cps2-can-gamble]";
    ErrorCodes["PlayerLimitCrossedKycSimpleVerified"] = "player_limit_crossed : [kyc-simple-verified]";
    ErrorCodes["PlayerLimitCrossedKycVerified"] = "player_limit_crossed : [kyc-verified]";
    ErrorCodes["PlayerLimitCrossedPlayerRequiredRequisites"] = "player_limit_crossed : [player-required-requisites]";
    ErrorCodes["WagerLimitReached"] = "Wager limit you have set has been already reached";
    ErrorCodes["BetTypeIsForbidden"] = "BET_TYPE_IS_FORBIDDEN";
    ErrorCodes["RestrictionsViolated"] = "restrictions_violated";
    ErrorCodes["InternalError"] = "internal_error";
    ErrorCodes["BetRateLimitReached"] = "BET_RATE_LIMIT_REACHED";
    ErrorCodes["MarketIsDefective1"] = "MARKET_IS_DEFECTIVE";
    ErrorCodes["MarketIsDefective2"] = "marketDefective";
    ErrorCodes["FreebetAlreadyUsed"] = "already_used";
    ErrorCodes["FreebetExpired"] = "freebet_expired";
    ErrorCodes["FreebetInvalidStatus"] = "invalid_status";
    ErrorCodes["FreebetNotFound"] = "freebet_not_found";
    ErrorCodes["FreebetNotApplicableContext"] = "not_applicable_context";
})(ErrorCodes = exports.ErrorCodes || (exports.ErrorCodes = {}));
var ErrorCodesMapping = /** @class */ (function () {
    function ErrorCodesMapping() {
        this[_c] = 'insufficientFunds';
        this[_d] = 'insufficientFunds';
        this[_e] = 'stakeExceedsMaxBet';
        this[_f] = 'stakeExceedsMaxBet';
        this[_g] = 'betslipRejected';
        this[_h] = 'responseTimedOut';
        this[_j] = 'playerIpThisIsNotAValidIpAddress';
        this[_k] = 'authCredentialsExpired';
        this[_l] = 'authSessionUnknown';
        this[_m] = 'betOnDifferentProviders';
        this[_o] = 'betLimitExceeded';
        this[_p] = 'bettingIsSuspended';
        this[_q] = 'bettingIsSuspended';
        this[_r] = 'internalErrorInvalidMatchStatus';
        this[_s] = 'internalErrorInvalidMatchStatus';
        this[_t] = 'internalErrorInvalidMarketStatus';
        this[_u] = 'internalErrorInvalidMarketStatus';
        this[_v] = 'coefsHaveChanged';
        this[_w] = 'internalErrorInvalidOddsStatus';
        this[_x] = 'internalErrorInvalidOddsStatus';
        this[_y] = 'internalErrorInvalidOddsStatus';
        this[_z] = 'internalErrorInvalidOddsStatus';
        this[_0] = 'stakeMinimalStakeIs';
        this[_1] = 'stakeExceedsMaxBet';
        this[_2] = 'placeRetryLimitReached';
        this[_3] = 'identicalBetIsProcessing';
        this[_4] = 'betIsForbidden';
        this[_5] = 'playerLimitCrossed';
        this[_6] = 'playerLimitCrossed';
        this[_7] = 'verifiedPlayerLimitCrossed';
        this[_8] = 'verifiedPlayerLimitCrossed';
        this[_9] = 'playerRequiredRequisites';
        this[_10] = 'gamblerBlocked';
        this[_11] = 'betTypeIsForbidden';
        this[_12] = 'betAmountRestrictionCrossed';
        this[_13] = 'internalError';
        this[_14] = 'betRateLimitReached';
        this[_15] = 'marketIsDefective';
        this[_16] = 'marketIsDefective';
        this[_17] = 'freebetAlreadyUsed';
        this[_18] = 'freebetExpired';
        this[_19] = 'freebetInvalidStatus';
        this[_20] = 'freebetNotFound';
        this[_21] = 'freebetNotApplicableContext';
    }
    return ErrorCodesMapping;
}());
_c = ErrorCodes.NotEnoughBalance1, _d = ErrorCodes.NotEnoughBalance2, _e = ErrorCodes.StakeExceedsLimit, _f = ErrorCodes.StakeIsTooBig, _g = ErrorCodes.TicketWasRejected, _h = ErrorCodes.ResponseTimedOut, _j = ErrorCodes.PlayerIp, _k = ErrorCodes.AuthCredentialsExpired, _l = ErrorCodes.AuthSessionUnknown, _m = ErrorCodes.BetOnDifferentProviders, _o = ErrorCodes.MatchLimitExceeded, _p = ErrorCodes.ApiMatchInBetStopList, _q = ErrorCodes.ApiMatchInBetStopList2, _r = ErrorCodes.ApiMatchStatusWrong, _s = ErrorCodes.ApiMatchStatusWrong2, _t = ErrorCodes.ApiMarketStatusWrong, _u = ErrorCodes.InvalidMarketStatus, _v = ErrorCodes.ApiOddValueWrong, _w = ErrorCodes.InvalidSelectionValue, _x = ErrorCodes.InvalidOddStatus1, _y = ErrorCodes.InvalidOddStatus2, _z = ErrorCodes.ApiOddStatusWrong, _0 = ErrorCodes.MinimalStakeIs, _1 = ErrorCodes.MaxStakeIs, _2 = ErrorCodes.PlaceRetryLimitReached, _3 = ErrorCodes.IdenticalBetIsProcessing, _4 = ErrorCodes.BetForThisPlayerIsForbidden, _5 = ErrorCodes.PlayerLimitCrossed, _6 = ErrorCodes.PlayerLimitCrossedCps2CanGamble, _7 = ErrorCodes.PlayerLimitCrossedKycSimpleVerified, _8 = ErrorCodes.PlayerLimitCrossedKycVerified, _9 = ErrorCodes.PlayerLimitCrossedPlayerRequiredRequisites, _10 = ErrorCodes.WagerLimitReached, _11 = ErrorCodes.BetTypeIsForbidden, _12 = ErrorCodes.RestrictionsViolated, _13 = ErrorCodes.InternalError, _14 = ErrorCodes.BetRateLimitReached, _15 = ErrorCodes.MarketIsDefective1, _16 = ErrorCodes.MarketIsDefective2, _17 = ErrorCodes.FreebetAlreadyUsed, _18 = ErrorCodes.FreebetExpired, _19 = ErrorCodes.FreebetInvalidStatus, _20 = ErrorCodes.FreebetNotFound, _21 = ErrorCodes.FreebetNotApplicableContext;
exports.errorCodes = new ErrorCodesMapping();
exports.PARTS_OF_ERROR_CODES = {
    'Internal Error': 'internalError',
    'player_limit_crossed : [': 'playerLimitCrossedDefault',
    'de-kyc-deposit': 'deKycDeposit',
};
exports.DEFAULT_MAX_STAKE = 10000;
exports.DEFAULT_AVAILABLE_STAKES = [
    100,
    500,
    1000,
    5000,
    exports.DEFAULT_MAX_STAKE,
];
var BetslipSettingKey;
(function (BetslipSettingKey) {
    BetslipSettingKey["BETSLIP_ODD_UPDATE_STRATEGY"] = "betslipOddUpdateStrategy";
})(BetslipSettingKey = exports.BetslipSettingKey || (exports.BetslipSettingKey = {}));
var KeyPathToReducerProp = /** @class */ (function () {
    function KeyPathToReducerProp() {
        this[_22] = 'oddUpdateStatus';
    }
    return KeyPathToReducerProp;
}());
exports.KeyPathToReducerProp = KeyPathToReducerProp;
_22 = BetslipSettingKey.BETSLIP_ODD_UPDATE_STRATEGY;
exports.BETSLIP_GAMBLER_SETTINGS = (_a = {},
    _a[exports.NAME] = __assign({}, new KeyPathToReducerProp()),
    _a);
exports.ODD_ACCEPT_STRATEGIES_MAPPING = (_b = {},
    _b[core_1.App.OddUpdateStatus.alwaysAsk] = core_1.GQL.OddAcceptStrategy.DEVIATION_ALLOWED,
    _b[core_1.App.OddUpdateStatus.acceptHigher] = core_1.GQL.OddAcceptStrategy.GREATER_ALLOWED,
    _b[core_1.App.OddUpdateStatus.acceptAll] = core_1.GQL.OddAcceptStrategy.ALWAYS_ALLOWED,
    _b);
exports.BETSLIP_ODD_STATUSES_TO_PLACE_BET = [
    core_1.App.BetslipStatus.INITIAL,
    core_1.App.BetslipStatus.ERROR,
];
//# sourceMappingURL=constants.js.map